import { render } from "./FlaskBlock.vue?vue&type=template&id=525a089e&scoped=true"
import script from "./FlaskBlock.vue?vue&type=script&lang=js"
export * from "./FlaskBlock.vue?vue&type=script&lang=js"

import "./FlaskBlock.vue?vue&type=style&index=0&id=525a089e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525a089e"]])

export default __exports__